/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import Report from './pages/reports/Report'
import LpList from './pages/lplist/LpList';
import TopMenu from './components/TopMenu';
import CreateLP from './pages/createlp/CreateLP';
import EditLp from './pages/editlp/EditLp';
import ViewLp from './pages/viewlp/ViewLp';
import PreviewLp from './pages/previewlp/PreviewLp';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';


import { AuthServ } from "./services/api/AuthServ";
import { setAuth } from './slices/authSlice';



import './App.css';
import PreviewEmail from './pages/previewemail/PreviewEmail';
import S3Explorer from './pages/s3explorer/S3Explorer';
import CreateExternalLP from './pages/createexternallp/CreateExternalLP';
import ViewExternalLP from './pages/viewexternallp/ViewExternalLP';
import EditExternalLP from './pages/editexternallp/EditExternalLP';


function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const getMe = async () => {
    try {
      let res = await AuthServ.single();
      dispatch(setAuth(res.user))
    } catch (error) {
      console.log(error)
    } finally {

    }
  }

  useEffect(() => {
    const token = localStorage.getItem('token');
    document.title = 'LP GEN'
    if (token) {
      getMe();
    }
  }, []);

  const auth = useSelector((state) => state.auth)


  const privateRoutes = (
    <>
    <Route path="/reports" element={<Report />}></Route>
      <Route path="lplist" element={<LpList />}></Route>
      <Route path="edit-lp/:id" element={<EditLp />}></Route>
      <Route path="create-lp" element={<CreateLP />}></Route>
      <Route path="view-lp/:id" element={<ViewLp />}></Route>
      <Route path="s3-explorer" element={<S3Explorer />}></Route>
      <Route path="create-external-lp" element={<CreateExternalLP />}></Route>
      <Route path="view-external-lp/:id" element={<ViewExternalLP />}></Route>
      <Route path="edit-external-lp/:id" element={<EditExternalLP />}></Route>

    </>
  );
  return (
    <>
      {!currentPath.includes('preview') && <div className='menu'>
        <TopMenu></TopMenu>
      </div>}
      <div className='container'>
        <Routes>
          {auth.isLogged ? privateRoutes : null}
          <Route path="/home" element={<HomePage />}></Route>
          <Route path="/reports" element={<Report />}></Route>
          <Route path="preview/:id/:title" element={<PreviewLp />}></Route>
          <Route path="preview-email/:id/:title" element={<PreviewEmail />}></Route>
          <Route path="/" element={<Navigate  to="/home" />}></Route>
          <Route path="*" element={<h1>Page Not Found</h1>}></Route>
        </Routes>
      </div>

    </>
  );
}

export default App;
